import { create } from "zustand";
import { persist } from "zustand/middleware";

const ROLE_PERMS = {
  admin: ["*"],
};

export const useAuthStore = create(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      setAuth: (token, user) => set({ token, user }),
      setUser: (user) => set({ user }),
      logout: () => set({ token: null, user: null }),
      can: (perm) => {
        const u = get().user;
        if (!u) return false;
        if (u.role === "admin" || ROLE_PERMS[u.role]?.includes("*")) return true;
        return (u.effective_permissions || []).includes(perm);
      },
      isAdmin: () => get().user?.role === "admin",
    }),
    { name: "crm-auth" }
  )
);
